import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
	selector: "cp-grid-no-records",
	templateUrl: './grid.no.records.html',
	styleUrls: ['./grid.no.records.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush,
})
export class GridNoRecordsComponent {

}
